<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="region" clearable placeholder="输入区域,GB,ID,JP,等">
        </el-input>
      </el-col>
      <el-col :span="4">
      <el-radio-group v-model="dataScope">
        <el-radio-button label="所有数据" ></el-radio-button>
        <el-radio-button label="只看新增" ></el-radio-button>
      </el-radio-group>
      </el-col>
      <el-col :span="4" >
        <el-button icon="el-icon-search" @click="searchPageData"
        >搜索</el-button
        >
        <el-button icon="el-icon-download" @click="exportSelectedData" alt=""
        >下载</el-button
        >
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
          background
          @current-change="queryGoodsPage"
          layout="total, prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
          ref="dataTable"
          :data="items"
          style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="keyword" label="日期/关键词/区域">
          <template scope="scope">
            {{ scope.row.crawlerVersion }}
            /{{ scope.row.keyword }}
            /{{ scope.row.region }}
          </template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column prop="videoId" label="视频ID"></el-table-column>
        <el-table-column prop="desc" label="描述"></el-table-column>
        <el-table-column label="视频地址" width="100">
          <template scope="scope">
            <a :href="scope.row.url">打开视频</a>
          </template>
        </el-table-column>
        <el-table-column prop="createTimeStr" label="发布日期"></el-table-column>
        <el-table-column label="视频封面" width="100">
          <template scope="scope">
            <img
                :src="scope.row.cover"
                width="100"
                height="200"
                class="head_pic"
            />
          </template>
        </el-table-column>
        <el-table-column label="播放地址" width="100">
          <template scope="scope">
           <a :href="scope.row.playAddr">播放</a>
          </template>
        </el-table-column>
        <el-table-column prop="stats" label="播放信息">
          <template scope="scope">
            评论数:{{ scope.row.commentCount }} <br />
            喜欢:{{ scope.row.diggCount }} <br />
            播放次数:{{ scope.row.playCount }} <br />
            分享数量: {{scope.row.shareCount}}<br />
          </template>
        </el-table-column>
        <el-table-column prop="authorId" label="作者信息">
          <template scope="scope">
            UID:{{ scope.row.authorId }} <br />
            昵称:{{ scope.row.authorNickname }} <br />
            tiktok号:{{ scope.row.authorUniqueId }} <br />
            签名: {{scope.row.authorAvatarSignature}}<br />
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
export default {
  name: "titkVideoItemSearch",
  data() {
    return {
      items: [],
      keyword: "",
      region: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
      dataScope: '所有数据'
    };
  },
  methods: {
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      if (this.region !== "") {
        para += "&region=" + this.region;
      }
      if(this.dataScope === '只看新增') {
        para += "&scope=1" ;
      }

      window.open("/api/tiktok/export/videos?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword.replace('+','%2B');
      }

      if (this.region !== "") {
        para += "&region=" + this.region;
      }
      if(this.dataScope === '只看新增') {
        para += "&scope=1" ;
      }


      axios
          .get("/api/tiktok/video/queryPage?currentPage=" + pageNum + "&pageSize=50" + para)
          .then((content) => {
            if (content.data.status === 0) {
              console.log(content.data.data)
              _this.items = content.data.data;
              _this.totalItems = content.data.total;
            }
          });
    },
  },
  mounted() {
    this.loadItemInfo(1);
  },
};
</script>
